type Kind = 'inner' | 'crawdads' | 'king' | 'educated' | 'handmaid' | 'designer' | string;

const COVERS: Record<string, JSX.Element> = {
  inner: (
    <svg viewBox="0 0 100 140" className="w-full h-full">
      <rect width="100" height="140" fill="#F4EEE1"/>
      <circle cx="50" cy="62" r="26" fill="none" stroke="#0F3D2C" strokeWidth="1.2"/>
      <path d="M24 62 H76 M50 36 V88" stroke="#0F3D2C" strokeWidth=".6"/>
      <text x="50" y="112" textAnchor="middle" fontFamily="Fraunces" fontSize="7" fill="#0F3D2C" letterSpacing=".5">INNER GAME</text>
      <text x="50" y="122" textAnchor="middle" fontFamily="Inter" fontSize="4" fill="#6F6B62">W.T. GALLWEY</text>
    </svg>
  ),
  crawdads: (
    <svg viewBox="0 0 100 140" className="w-full h-full">
      <rect width="100" height="140" fill="#E8A86B"/>
      <path d="M0 100 Q30 80 60 95 T100 90 V140 H0Z" fill="#C17545"/>
      <circle cx="70" cy="38" r="10" fill="#F5E3A4"/>
      <text x="50" y="58" textAnchor="middle" fontFamily="Fraunces" fontSize="7" fontWeight="700" fill="#3A2515">WHERE THE</text>
      <text x="50" y="68" textAnchor="middle" fontFamily="Fraunces" fontSize="9" fontWeight="700" fill="#3A2515">CRAWDADS</text>
      <text x="50" y="78" textAnchor="middle" fontFamily="Fraunces" fontSize="9" fontWeight="700" fill="#3A2515">SING</text>
      <text x="50" y="126" textAnchor="middle" fontFamily="Inter" fontSize="4" fill="#3A2515">DELIA OWENS</text>
    </svg>
  ),
  king: (
    <svg viewBox="0 0 100 140" className="w-full h-full">
      <rect width="100" height="140" fill="#14332B"/>
      <rect x="35" y="45" width="30" height="50" fill="#F4D35E" opacity=".9"/>
      <rect x="42" y="55" width="16" height="35" fill="#14332B"/>
      <text x="50" y="30" textAnchor="middle" fontFamily="Fraunces" fontSize="10" fontWeight="700" fill="#F4D35E" letterSpacing="1">STEPHEN</text>
      <text x="50" y="40" textAnchor="middle" fontFamily="Fraunces" fontSize="10" fontWeight="700" fill="#F4D35E" letterSpacing="1">KING</text>
      <text x="50" y="112" textAnchor="middle" fontFamily="Fraunces" fontSize="9" fontWeight="700" fill="#F4D35E" letterSpacing="2">THE</text>
      <text x="50" y="122" textAnchor="middle" fontFamily="Fraunces" fontSize="9" fontWeight="700" fill="#F4D35E" letterSpacing="2">INSTITUTE</text>
    </svg>
  ),
  educated: (
    <svg viewBox="0 0 100 140" className="w-full h-full">
      <rect width="100" height="140" fill="#C4A86A"/>
      <path d="M30 80 L50 45 L70 80 Z" fill="#F4EEE1"/>
      <text x="50" y="106" textAnchor="middle" fontFamily="Fraunces" fontSize="10" fontWeight="700" fill="#1A1A1A" letterSpacing="2">EDUCATED</text>
      <text x="50" y="120" textAnchor="middle" fontFamily="Inter" fontSize="4" fill="#1A1A1A">TARA WESTOVER</text>
    </svg>
  ),
  handmaid: (
    <svg viewBox="0 0 100 140" className="w-full h-full">
      <rect width="100" height="140" fill="#0E0D0B"/>
      <path d="M50 50 C40 55 36 68 40 80 C44 92 56 92 60 80 C64 68 60 55 50 50Z" fill="#8B1A1A"/>
      <circle cx="50" cy="54" r="8" fill="#8B1A1A"/>
      <text x="50" y="112" textAnchor="middle" fontFamily="Fraunces" fontSize="7" fontWeight="700" fill="#F4EEE1">THE HANDMAID'S TALE</text>
      <text x="50" y="122" textAnchor="middle" fontFamily="Inter" fontSize="4" fill="#F4EEE1">MARGARET ATWOOD</text>
    </svg>
  ),
  designer: (
    <svg viewBox="0 0 100 140" className="w-full h-full">
      <rect width="100" height="140" fill="#F4EEE1"/>
      <circle cx="35" cy="40" r="14" fill="#0F3D2C"/>
      <rect x="50" y="28" width="28" height="28" fill="#D97757"/>
      <path d="M20 80 L50 58 L80 80 Z" fill="#1A1A1A"/>
      <text x="50" y="106" textAnchor="middle" fontFamily="Fraunces" fontSize="8" fontWeight="700" fill="#1A1A1A">A DESIGNER'S ART</text>
      <text x="50" y="118" textAnchor="middle" fontFamily="Inter" fontSize="4" fill="#6F6B62">PAUL RAND</text>
    </svg>
  ),
};

export const Cover = ({ kind = 'inner', dataUrl, className = '' }: { kind: Kind; dataUrl?: string | null; className?: string }) => (
  <div className={`relative overflow-hidden ${className}`} style={{ boxShadow: '0 10px 30px -12px rgba(20,18,15,.25)' }}>
    {dataUrl ? (
      <img src={dataUrl} alt="" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
    ) : (
      <div className="absolute inset-0">{COVERS[kind] || COVERS.inner}</div>
    )}
  </div>
);
